import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { cleanHtml } from '../../../../utils/stringHelper';

function ProgramListItem({ program, handleClickProgram }) {
  return (
    <div
      className="w-full flex flex-row justify-between items-end p-5 cursor-pointer hover:bg-slate-100"
      onClick={handleClickProgram}>
      <div className="h-full flex flex-row gap-x-5">
        <img
          className="h-32 w-auto shadow-md block rounded-md"
          src={program.main_image ? program.main_image.file : getImage('img-ph.png')}
          alt={program.main_image ? program.main_image.label : 'Non renseignée'}
        />
        <img
          className="h-32 w-auto shadow-md block rounded-md"
          src={program.secondary_image ? program.secondary_image.file : getImage('img-ph.png')}
          alt={program.secondary_image ? program.secondary_image.label : 'Non renseignée'}
        />
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col gap-y-0.5">
            <h3 className="text-xl font-bold text-slate-700 ">{program.title}</h3>
            <p
              dangerouslySetInnerHTML={{ __html: cleanHtml(program.description) }}
              className="line-clamp-2"
            />
          </div>

          <Tag tag={getConstant('melismes.common.statusTypes', program.status)} />
        </div>
      </div>
    </div>
  );
}

export default ProgramListItem;
